'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import type { TDynamicData } from '../types/dynamic-data';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

import { Navigation } from 'swiper/modules';
import { useState } from 'react';

export const TypesOfMetalWork = ({ title, types }: { title: string; types: TDynamicData[] }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="flex w-full flex-col items-center justify-center gap-12 sm:gap-16 lg:gap-24">
      <h2 className="px-6 text-3xl font-bold">{title}</h2>
      <div className="h-[260px] sm:h-[450px] md:h-[500px] lg:h-[600px] xl:h-[780px] 2xl:min-h-[800px] w-full">
        <Swiper
          navigation={true}
          modules={[Navigation]}
          className="mySwiper custom-container ea-custom-container w-full"
          slidesPerView={'auto'}
          spaceBetween={16}
          onSlideChange={swiper => setActiveIndex(swiper.activeIndex)}
          centeredSlides={true}
          breakpoints={{
            1280: {
              spaceBetween: 32,
            },
            1024: {
              spaceBetween: 24,
            },
            768: {
              spaceBetween: 18,
            },
          }}
        >
          {types.map((type, index) => {
            const isActiveSlide = index === activeIndex;
            const maxWidth = isActiveSlide ? 'min(1318px, 85vw)' : 'min(1120px, 50vw)';

            return (
              <SwiperSlide
                key={type.name}
                style={{
                  maxWidth: maxWidth,
                  transition: 'max-width 0.2s ease-in-out', // Apply the transition directly here
                }}
                className="relative my-auto aspect-video"
              >
                <h3 className="absolute bottom-4 left-4 z-10 text-2xl font-bold uppercase text-white sm:bottom-6 sm:left-6 sm:text-3xl lg:bottom-12 lg:left-12 lg:text-4xl xl:bottom-16 xl:left-16 xl:text-5xl">
                  {type.name}
                </h3>
                <div className="ea-metal-type__slide-overlay absolute inset-0 z-[1] h-full w-full" />
                <Image
                  src={type?.image?.url ?? '/images/placeholder.png'}
                  alt={resolveImageAlt(type?.image, type?.name)}
                  fill
                  className="absolute inset-0 z-0 h-full w-full object-cover object-center"
                  sizes="100vw"
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};
